import React from "react";
import { Avatar } from "antd";

export interface RecipientOption {
  contact_id: string;
  firstname: string;
  lastname: string;
  fax_number: string;
}

export type RecipientOptionLabelType = "name" | "fax";

/**
 * Renders the label for a recipient option, used in SelectBar options.
 * @param option The recipient option object
 * @returns JSX.Element
 */
export function renderRecipientOptionLabel(
  option: RecipientOption
): JSX.Element {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <Avatar
        size={32}
        style={{
          backgroundColor: "#d9d9d9",
          color: "#595959",
        }}
      >
        {option.firstname
          ? option.firstname.charAt(0).toUpperCase()
          : option.fax_number
          ? option.fax_number.charAt(0)
          : "?"}
      </Avatar>
      <div>
        <div className="hide-option">
          {option.firstname} {option.lastname}
        </div>
        <div style={{ fontSize: 12, color: "#888" }}>{option.fax_number}</div>
      </div>
    </div>
  );
}

/**
 * Maps recipient options to SelectBar options with custom label rendering.
 * @param options Array of recipient options
 * @param label2Type Whether to use name or fax_number for label2
 */
export function mapRecipientOptions(
  options: RecipientOption[],
  label2Type: RecipientOptionLabelType = "name"
) {
  return options.map((option) => ({
    value: option.contact_id,
    label: renderRecipientOptionLabel(option),
    label2:
      label2Type === "fax"
        ? option.fax_number
        : `${option.firstname} ${option.lastname}`,
  }));
}
